import { render, staticRenderFns } from "./PromoTemplateDetail.vue?vue&type=template&id=47e55849&"
import script from "./PromoTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./PromoTemplateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports